<template>
  <div>
    <v-row>
      <h1 class="ml-4">Building Tags</h1>
    </v-row>
    <v-row class="mt-2 reduce-zoom">
      <v-col> </v-col>
      <v-col> </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-card class="mt-3">
      <v-card-title>
        <v-text-field
          v-model="search"
          placeholder="Type an buildingTags description to search..."
          outlined
          clearable
          counter
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="buildingTags.records"
          :loading="isLoading"
          :search="search"
          transition="scale-transition"
          class="new-detault-table buildingTags-view"
        >
          <template v-slot:top>
            <v-row class="card-slider mb-4" justify="center">
              <v-col cols="12" sm="4" md="4" lg="4">
                <download-excel
                  class="text-right"
                  :data="buildingTags.records"
                  :fields="fields"
                  worksheet="BuildingTags"
                  description="CRMBuildingTagList.xls"
                >
                  <v-btn class="text-right" color="#0a2752" large dark>
                    <h1>Download</h1>
                  </v-btn>
                </download-excel>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4">
                <v-btn
                  dark
                  color="primary"
                  large
                  @click="$router.push('/admin/buildingTag/0/edit')"
                  ><h1>Create new BuildingTag</h1></v-btn
                >
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.createdAt="{ item }">
            <h3 color="primary">{{ item.createdAt | getFormattedDate }}</h3>
          </template>
          <template v-slot:item.updatedAt="{ item }">
            <h3 color="primary">{{ item.updatedAt | getFormattedDate }}</h3>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              fab
              x-small
              dark
              class="mr-2"
              @click="editItem(item)"
              color="primary"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn fab x-small dark class="ml-2" @click="deleteItem(item)">
              <v-icon color="blue darken-2">mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import defaultProfile from "../../../assets/img/avatar.png";

export default {
  components: { defaultProfile },
  data() {
    return {
      fields: {
        "BuildingTag Name": "description",
        "BuildingTag Id": "id",
        "Created At": "createdAt",
      },
      headers: [
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "description",
        },

        { text: "Actions", align: "right", sortable: false, value: "actions" },
      ],
      search: "",
      buildingTags: [],
      totalRecords: 0,
      isLoading: false,
    };
  },

  apollo: {
    buildingTags: {
      query: gql`
        query BuildingTags($limit: Int!, $skip: Int!, $query: JSON!) {
          buildingTags(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              description
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const self = this;
        const limit = 9999;
        const skip = 0;
        return {
          limit: limit,
          skip: skip,
          query: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
  },

  methods: {
    editItem(item) {
      this.$router.push(`/admin/buildingTag/${item.id}/edit`);
    },

    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deleteBuildingTag(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: {
                id: item.id,
              },
            });

            if (response) {
              this.$swal(
                "Success!",
                "Building Tag was successfully deleted",
                "success"
              );
              this.$router.go(this.$route.currentRoute);
            }
          } catch (e) {}
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
